import React, {useCallback, useEffect, useRef, useState} from "react";
import {observer} from "mobx-react";
import {SparkSwiperBox} from "./boxes/spark-swiper.box";
import {ISparkSwiperSlideController} from "./models/spark-swiper-slide-controller.interface";
import {ISparkSwiperController} from "./models/spark-swiper-controller.interface";
import {SparkSwiperSlideComponent} from "./spark-swiper-slide.component";
import {SPARK_SWIPE_DELTA_THRESHOLD} from "./spark-swiper-consts";

interface SparkSwiperComponentProps {
    swiperController: ISparkSwiperController;
}

export const SparkSwiperComponent: React.FC<SparkSwiperComponentProps> = observer((props) => {
    const swiperController = props.swiperController;
    const swiperElementRef = useRef<HTMLDivElement | null>(null);
    const touchStartY = useRef(0);
    const [touchMoveDelta, setTouchMoveDelta] = useState(0);
    const [animationStarted, setAnimationStarted] = useState(false);


    const onTransitionEndHandler = () => {
        if(touchMoveDelta < -1 * SPARK_SWIPE_DELTA_THRESHOLD) {
            swiperController.moveNext();
        } else if(touchMoveDelta > SPARK_SWIPE_DELTA_THRESHOLD){
            swiperController.movePrevious();
        }
        setAnimationStarted(false);
        setTouchMoveDelta(0);
    };

    const onTouchStartHandler = (event: any) => {
        touchStartY.current = event.touches[0].clientY;
    }

    const onTouchMoveHandler = useCallback((event: any) => {
        event.preventDefault();

        const deltaY = event.touches[0].clientY - touchStartY.current;
        setTouchMoveDelta(deltaY);
    }, [])

    const onTouchEndHandler = (event: any) => {
        const deltaY = event.changedTouches[0].clientY - touchStartY.current;
        setTouchMoveDelta(deltaY);
        setAnimationStarted(true);
    };

    useEffect(() => {
        const swiper = swiperElementRef.current;
        if(swiper) {
            swiper.addEventListener('touchmove', onTouchMoveHandler, { passive: false });
        }

        return () => {
            if(swiper) {
                swiper.removeEventListener('touchmove', onTouchMoveHandler);
            }

        };
    }, [onTouchMoveHandler]);



    const renderOneSlide = (slideController: ISparkSwiperSlideController) => {
        return (
            <SparkSwiperSlideComponent key={slideController.key}
                                       slideController={slideController}
                                       swiperController={swiperController}
                                       touchMoveDelta={touchMoveDelta}
                                       animationStarted={animationStarted}
                                       onTransitionEnd={slideController.itemIndexOffset === 0 ? onTransitionEndHandler : undefined} />
        );
    }

    return (
        <SparkSwiperBox ref={swiperElementRef} onTouchStart={onTouchStartHandler} onTouchEnd={onTouchEndHandler}>
            {swiperController.slides.map(renderOneSlide)}
        </SparkSwiperBox>
    )
})